import { SUPPORTED_LANGUAGES } from './language.config';
// 支持的语言列表
// 该列表由 language.config.ts 动态生成，以确保单一数据源。
export const LANGUAGES = [
    { code: 'auto', name: 'Auto-Detect', isAuto: true },
    ...SUPPORTED_LANGUAGES.map(lang => ({
        code: lang.code,
        name: lang.nativeName, // 根据用户反馈，使用原生名称作为显示名称
    })),
];
// 不支持的语言对
export const UNSUPPORTED_LANGUAGE_PAIRS = [];
// 默认语言常量
export const DEFAULT_SOURCE_LANGUAGE = 'auto';
export const DEFAULT_TARGET_LANGUAGE = 'en';
//# sourceMappingURL=languages.js.map